var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhereYourMoneyGoesAltroi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DEDBC9",
  d: "M294.704 150.22a145 145 0 0 1-25.908 83.065l-119.091-82.717z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#015d59",
  d: "M259.586 227.433A135 135 0 1 1 284 150.189L149 150z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F27B30",
  d: "M284.119 149.982c0 20.158-4.514 40.061-13.212 58.247l-121.788-58.247z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD03",
  d: "M270.906 208.23a135 135 0 0 1-8.722 15.517l-113.065-73.765z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D22267",
  d: "M262.055 223.99a134 134 0 0 1-2.38 3.511L149.137 150z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M198.847 149.982c0 27.614-22.385 50-50 50s-50-22.386-50-50 22.386-50 50-50 50 22.386 50 50"
})));
export default SvgWhereYourMoneyGoesAltroi;